import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'documentFileSizeUsedToPercentage',
    standalone: false
})
export class DocumentFileSizeUsedToPercentagePipe implements PipeTransform {

  transform(fileSizeUsedMB: number, fileSizeLimitMB): number {
    return (fileSizeUsedMB / fileSizeLimitMB) * 100;
  }

}
